import {
  nextTick, onActivated, onMounted, onUnmounted, ref,
} from 'vue';

export const useKeepScroll = () => {
  const el = ref<HTMLElement | null>(null);
  // 滚动距离
  let _lastTop = 0;
  const handleScroll = () => {
    if (el.value) {
      _lastTop = el.value.scrollTop;
    }
  };

  onMounted(() => {
    el.value?.addEventListener('scroll', handleScroll);
  });

  onUnmounted(() => {
    el.value?.removeEventListener('scroll', handleScroll);
  });

  onActivated(() => {
    nextTick(() => {
      if (el.value) {
        el.value.scrollTop = _lastTop;
      }
    });
  });

  return {
    el,
  };
};
